// extracted by mini-css-extract-plugin
module.exports = {"link":"_8552c41","linkWrapper":"_58c8441","oddsBoostIcon":"_1716461","sportIcon":"_6cc6285","linkText":"_4991133","linkIcon":"_bd2b791"};